import { P } from "../../../../../AbstractElements";
import { Href, RecentChats } from "../../../../../Constants/Constants";
import ChatUserProfile from "./ChatUserProfile";

export const ChatTabPane = () => {
  return (
    <>
      <div className="common-space">
        <P>{RecentChats}</P>
        <div className="header-top">
          <a className="badge-light-primary f-w-500 btn" href={Href}>
            <i className="fa fa-plus" />
          </a>
        </div>
      </div>
      <ChatUserProfile />
    </>
  );
};
